function hasMoreValues(arrays, positions) {
  for (var i = 0; i < arrays.length; i++) {
    var arr = arrays[i];
    var pos = positions[i];

    if (arr.length > pos) {
      return true;
    }
  }

  return false;
}

function getLowestAtPosition(arrays, positions, encoders) {
  var lowestIndex = 0;
  var lowestValue = Infinity;

  for (var i = 0; i < arrays.length; i++) {
    var arr = arrays[i];
    var pos = positions[i];

    if (arr[pos] && arr[pos].time < lowestValue) {
      lowestIndex = i;
      lowestValue = arr[pos].time;
    }
  }

  encoders[lowestIndex](arrays[lowestIndex][positions[lowestIndex]]); // increment array

  positions[lowestIndex] += 1;
}
/**
 * Combine multiple arrays keeping the timing in order
 * The arguments should alternate between the array and the encoder callback
 * @param {...Array|Function} args
 */


function Merge() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var arrays = args.filter(function (v, i) {
    return i % 2 === 0;
  });
  var positions = new Uint32Array(arrays.length);
  var encoders = args.filter(function (v, i) {
    return i % 2 === 1;
  });
  var output = [];

  while (hasMoreValues(arrays, positions)) {
    getLowestAtPosition(arrays, positions, encoders);
  }
}

export { Merge };